import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=eab118c8&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=eab118c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab118c8",
  null
  
)

export default component.exports